import { NameIdModel } from '@ct/model';

export const informationSource: Map<string, NameIdModel> = new Map()
  .set('Equinor revised', { name: 'Equinor revised', id: 'Equinor revised' })
  .set('Algorithm', { name: 'Algorithm', id: 'Algorithm' })
  .set('Analyst', { name: 'Analyst', id: 'Analyst' })
  .set('Customs', { name: 'Customs', id: 'Customs' })
  .set('Fixture', { name: 'Fixture', id: 'Fixture' })
  .set('Fixture,Market', { name: 'Fixture,Market', id: 'Fixture,Market' })
  .set('Fixture,Port', { name: 'Fixture,Port', id: 'Fixture,Port' })
  .set('Market', { name: 'Market', id: 'Market' })
  .set('Market,Port', { name: 'Market,Port', id: 'Market,Port' })
  .set('Port', { name: 'Port', id: 'Port' })
  .set('US BoL', { name: 'US BoL', id: 'US BoL' });
